<script>
import ModuleTitle from "../common/ModuleTitle.vue";
import FileBoxDialog from "../common/FileBoxDialog.vue";
import NoData from "comp/common/NoData";
import FilePreview from "comp/content/FilePreview.vue";

import { getSubPageId7 } from "@/api/pageData";

import { hiddenPhone } from "@/utils/filters";

export default {
  name: "DialogId7",
  components: { ModuleTitle, FileBoxDialog, NoData, FilePreview },
  props: {
    currentModule: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      fileList: [],
      currentData: {},
      previewShow: false,
    };
  },
  computed: {
    pageDataFilter() {
      let memberList = [];
      for (let i = 0; i < this.pageData.length; i += 3) {
        memberList.push(this.pageData.slice(i, i + 3));
      }
      return memberList;
    },
  },
  created() {
    this.initPageData();
  },
  methods: {
    hiddenPhone,
    onFileClick(v) {
      this.currentData = v;
      this.previewShow = true;
    },
    onPhoneHidden(v) {
      this.pageData.forEach((item) => {
        if (item.id === v.id) item.phoneShow = !item.phoneShow;
      });
    },

    initPageData() {
      const params = {
        titleid: Number(this.currentModule.titleid),
        userid: localStorage.getItem("screenUserid") || 0,
      };
      getSubPageId7(params).then((res) => {
        if (res.code === 0) {
          this.pageData = res.msg[0].list;
          this.pageData &&
            this.pageData.length > 0 &&
            this.pageData.forEach((item) => {
              this.$set(item, "phoneShow", false);
            });
          if (res.msg[1]) this.fileList = res.msg[1].list;
        }
      });
    },
  },
};
</script>

<template>
  <div class="dialog-id-7">
    <module-title :title="currentModule.title" margin-bottom="40" />
    <div
      v-if="pageDataFilter && pageDataFilter.length > 0"
      class="dialog-container"
      :class="{
        'limit-container': currentModule.id === 4,
        'has-fileList': fileList.length > 0,
      }"
    >
      <div
        v-for="(v, i) in pageDataFilter"
        :key="`group-member-${i}`"
        class="member-group"
      >
        <div class="item-group">
          <div
            v-for="(item, idx) in v"
            :key="`member-item-${idx}`"
            class="item"
          >
            <div class="item-main">
              <el-image
                class="item-avator"
                :src="item.photo | imgPath"
                alt="avator"
                fit="cover"
              />
              <div class="item-message">
                <p class="item-name">姓名: {{ item.name || "" }}</p>
                <p class="item-post" v-if="item.post">
                  职务: {{ item.post || "" }}
                </p>
                <p v-if="item.contactgroup" class="item-name">
                  联系组: {{ item.contactgroup || "" }}
                </p>
                <p class="item-phone" v-if="item.phone">
                  联系方式: {{ item.phone || "-" }}
                </p>
                <!-- <p class="item-phone">
                  联系方式: {{ item.phoneShow ? item.phone : hiddenPhone(item.phone) }}
                  <span @click="onPhoneHidden(item)">{{ item.phoneShow ? '隐藏' : '显示' }}</span>
                </p> -->
              </div>
            </div>
            <p v-if="currentModule.id !== 32" class="item-duty">
              职责：{{ item.duty || "暂无" }}
            </p>
          </div>
        </div>
        <el-image
          class="item-line"
          :src="require('imgs/modules/dialog-modules/id-7-line.png')"
          alt="line"
        />
      </div>
    </div>
    <no-data v-else />

    <div v-if="currentModule.id === 4" class="file-list">
      <file-box-dialog
        v-for="(v, i) in fileList"
        :key="`file-box-dialog-${i}`"
        :headline="v.headline"
        :filename="v.typename"
        @click.native="onFileClick(v)"
      />
    </div>

    <file-preview
      :preview-show="previewShow"
      :type="currentData.typeid"
      :headline="currentData.headline"
      :filename="currentData.typename"
      :createtime="currentData.createtime"
      @onModalClick="previewShow = false"
    />
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-container {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  row-gap: 40px;
  height: 610px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.has-fileList {
  height: 520px;
}
.limit-container {
  height: 510px;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    // chrome/safari
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #cdcdcd;
    border-radius: 3px;
  }
}
.file-list {
  width: 1200px;
  height: 50px;
  margin-top: 20px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  column-gap: 15px;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}

.item-group {
  display: flex;
  column-gap: 70px;
}
.item {
  width: 380px;
  color: #000;
  position: relative;
  .item-main {
    width: 100%;
    display: flex;
    .item-avator {
      width: 75px;
      height: 100px;
    }
    .item-message {
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      gap: 10px;
    }
    .item-name {
      font-size: 14px;
      font-weight: bold;
    }
    .item-post,
    .item-phone {
      font-size: 14px;
      font-weight: 600;
    }
    .item-phone {
      span {
        color: #999;
        margin-left: 2px;
        cursor: pointer;
      }
    }
  }
  .item-duty {
    width: 306px;
    font-size: 12px;
    font-weight: 600;
    margin-top: 10px;
  }
}
.item:not(:nth-child(3n + 0))::after {
  display: block;
  content: "";
  background: url("~imgs/modules/dialog-modules/id-7-line-vertical.png")
    no-repeat center;
  background-size: 100% 100%;
  width: 3px;
  height: 90px;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  // left: 0;
}

.item-line {
  width: 1207px;
  height: 18px;
  margin-top: 25px;
}
</style>
